import { useState, useEffect } from "react";
import styles from "./AdminForm.module.css";
import apiService from "../../../../services/api";
import { validateFile, createImagePreview, revokeImagePreview } from "../../../../utils/fileUpload";

export default function PressForm({ item, onSubmit, onCancel }) {
    const [formData, setFormData] = useState({
        title: "",
        content: "",
        imageFile: null,
        source: "",
        url: "",
        date: new Date().toISOString().split('T')[0]
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [fileError, setFileError] = useState("");

    useEffect(() => {
        if (item) {
            setFormData({
                title: item.title || "",
                content: item.content || "",
                imageFile: null,
                source: item.source || "",
                url: item.url || "",
                date: item.date ? new Date(item.date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            });
            // 기존 이미지가 있다면 미리보기로 설정
            if (item.imageUrl) {
                setImagePreview(item.imageUrl);
            }
        }
    }, [item]);

    // 컴포넌트 언마운트 시 이미지 미리보기 정리
    useEffect(() => {
        return () => {
            if (imagePreview && imagePreview !== item?.imageUrl) {
                revokeImagePreview(imagePreview);
            }
        };
    }, [imagePreview, item?.imageUrl]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // 파일 유효성 검사
        const validation = validateFile(file);
        if (!validation.isValid) {
            setFileError(validation.errors.join(', '));
            return;
        }

        setFileError("");
        setFormData({ ...formData, imageFile: file });
        
        // 이미지 미리보기 생성
        const preview = createImagePreview(file);
        setImagePreview(preview);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (fileError) {
            alert('이미지 파일을 확인해주세요: ' + fileError);
            return;
        }

        try {
            if (item) {
                await apiService.updatePress(item.id, formData);
            } else {
                await apiService.createPress(formData);
            }
            onSubmit();
        } catch (error) {
            alert("저장에 실패했습니다.");
        }
    };

    return (
        <form className={styles.formWrap} onSubmit={handleSubmit}>
            <h2 className={styles.title}>{item ? "언론보도 수정" : "언론보도 등록"}</h2>
            
            <label className={styles.label}>
                제목
                <input 
                    type="text" 
                    className={styles.input} 
                    value={formData.title}
                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                    required 
                />
            </label>
            
            <label className={styles.label}>
                내용
                <textarea 
                    className={styles.textarea} 
                    value={formData.content}
                    onChange={(e) => setFormData({...formData, content: e.target.value})}
                    required 
                />
            </label>
            
            <label className={styles.label}>
                이미지
                <div className={styles.imageUpload}>
                    <input
                        id="imageInput"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                    <div className={styles.imageUploadIcon}>📷</div>
                    <div className={styles.imageUploadText}>이미지를 선택하세요</div>
                    <div className={styles.imageUploadHint}>JPG, PNG, GIF, SVG 파일 지원</div>
                </div>
                {fileError && <div className={styles.error}>{fileError}</div>}
                {imagePreview && (
                    <div className={styles.imagePreview}>
                        <img 
                            src={imagePreview} 
                            alt="미리보기" 
                        />
                    </div>
                )}
            </label>
            
            <label className={styles.label}>
                언론사
                <input 
                    type="text" 
                    className={styles.input} 
                    value={formData.source}
                    onChange={(e) => setFormData({...formData, source: e.target.value})}
                    placeholder="언론사명을 입력하세요"
                />
            </label>
            
            <label className={styles.label}>
                원문 링크
                <input 
                    type="text" 
                    className={styles.input} 
                    value={formData.url}
                    onChange={(e) => setFormData({...formData, url: e.target.value})}
                    placeholder="원문 링크를 입력하세요"
                />
            </label>
            
            <label className={styles.label}>
                날짜
                <input 
                    type="date" 
                    className={styles.input} 
                    value={formData.date}
                    onChange={(e) => setFormData({...formData, date: e.target.value})}
                    required 
                />
            </label>
            
            <div className={styles.buttonGroup}>
                <button type="submit" className={styles.submitBtn}>
                    {item ? "수정" : "등록"}
                </button>
                <button type="button" onClick={onCancel} className={styles.cancelBtn}>
                    취소
                </button>
            </div>
        </form>
    );
}
